<div class="field-validation-container" [class.invalid]="isInvalid">
  <div
    [class.currency]="isCurrency"
    [class.number]="isNumber"
    [class.text]="isText"
    vpfaGetClientBoundingRect
    (boundingRectChanged)="updateErrorSignPosition($event)"
  >
    <ng-content></ng-content>
  </div>

  <div
    nz-popover
    [ngStyle]="{ 'top.px': errorSignTopPos, 'right.px': _errorMsgVertPosition }"
    [nzPopoverVisible]="displayErrors && isInvalid"
    [nzPopoverContent]="popoverContentTpl"
    [nzPopoverTrigger]="null"
    [hidden]="!isInvalid"
    [nzPopoverPlacement]="errorPopoverPlacement"
    class="error-sign"
  >
    <span *ngIf="displayErrors" class="zmdi zmdi-alert-triangle red app-theme-red"></span>
  </div>
</div>

<ng-template #popoverContentTpl>
  <span class="ssm-error-details {{ errorType }}" [innerHTML]="popoverContent | translate: errorData"></span>
</ng-template>
